<div class="modal-header"></div>
<div class="modal-body">
	<h1>{{ title }}</h1>
	<div class="body mt-3 mb-3" [innerHtml]="body" *ngIf="body && body.length > 0"></div>
</div>
<div *ngIf="modalConfirm" class="modal-footer border-0">
	<button
		type="button"
		class="btn btn-primary d-flex align-items-center justify-content-center w-100 w-md-initial me-4"
		(click)="activeModal.close('Deny')"
	>
		{{ buttonLeft }}
	</button>
	<button
		type="button"
		class="btn btn-primary d-flex align-items-center justify-content-center w-100 w-md-initial ms-4"
		(click)="activeModal.close('Accept')"
	>
		{{ buttonRight }}
	</button>
</div>
<div *ngIf="!modalConfirm" class="modal-footer border-0">
	<button
		type="button"
		class="btn btn-primary d-flex align-items-center justify-content-center w-100 w-md-initial"
		(click)="activeModal.close('Accept')"
	>
		{{ buttonText }}
	</button>
</div>
